async function defineCores(cores: string[]): Promise<void> {
  try {
    const nomesVariaveis = [
      '--color-theme-primary',
      '--color-theme-secondary',
      '--color-theme-light-secondary',
      '--color-theme-light-primary',
      '--font-size-texto-padrao',
      '--font-size-texto-botao',
      '--font-size-texto-titulo',
      '--font-size-texto-titulo-principal',
    ];

    nomesVariaveis.forEach((nome, index) => {
      document.documentElement.style.setProperty(nome, cores[index]);
    });
  } catch (error) {
    console.error('Erro ao definir as cores:', error);
  }
}

export default defineCores;
